import React from "react";
import BaseModal from "../BaseModal";
import Icon from "@mdi/react";
import { mdiCameraOutline, mdiTrashCanOutline } from "@mdi/js";
import "./StudentPhotoPreviewModal.css";

/**
 * StudentPhotoPreviewModal — shows a student's photo at full size with
 * "Change photo" and "Remove photo" actions. Shown when staff click an
 * existing photo on the check-in card or Students page.
 */
const StudentPhotoPreviewModal = ({
    isOpen,
    onClose,
    photoUrl,
    studentName,
    onChangePhoto,
    onRemovePhoto,
}) => {
    return (
        <BaseModal
            isOpen={isOpen}
            onClose={onClose}
            title={studentName || "Student Photo"}
            icon={mdiCameraOutline}
            footer={
                <>
                    <button
                        className="base-modal-cancel-btn"
                        onClick={onClose}
                    >
                        Close
                    </button>
                    <button
                        className="base-modal-save-btn student-photo-remove-btn"
                        onClick={() => { onClose(); onRemovePhoto(); }}
                    >
                        <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <Icon path={mdiTrashCanOutline} size={0.8} />
                            Remove Photo
                        </span>
                    </button>
                    <button
                        className="base-modal-save-btn"
                        onClick={() => { onClose(); onChangePhoto(); }}
                    >
                        <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <Icon path={mdiCameraOutline} size={0.8} />
                            Change Photo
                        </span>
                    </button>
                </>
            }
        >
            <div style={{ display: "flex", justifyContent: "center", padding: "8px 0" }}>
                <img
                    src={photoUrl}
                    alt={studentName || "Student"}
                    style={{
                        width: 200,
                        height: 200,
                        borderRadius: "50%",
                        objectFit: "cover",
                        boxShadow: "0 2px 12px rgba(0,0,0,0.15)",
                    }}
                />
            </div>
        </BaseModal>
    );
};

export default StudentPhotoPreviewModal;
